import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@material-ui/core";
import { useRouter } from "@uirouter/react";
import { isUndefined, noop } from "lodash";
import { FunctionComponent, useCallback, useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button } from "../../../../components/button";
import { TextField } from "../../../../components/forms/text";
import { useAppLoader } from "../../../../components/loader/app-loader-hook";
import { GlobalOverlayContext } from "../../../../components/overlay/context";
import { VerificationDTO } from "../../../../store/verification/models/dto/kyc";
import { VerificationService } from "../../../../store/verification/service";
import { StyledButton } from "./components";
import { SingleKycContext } from "./context";

interface ISaveDeclinedReasonsProps {}

const Modal = () => {
  const loader = useAppLoader();
  const router = useRouter();

  const { newDeclineCodes, item } = useContext(SingleKycContext);

  const validation = VerificationDTO.Requests.UpdateKycStatuses.useFields();

  const {
    control,
    handleSubmit,
  } = useForm<VerificationDTO.Requests.UpdateKycStatuses.T>({
    defaultValues: { serviceDeclineCodes: newDeclineCodes, note: "" },
    resolver: yupResolver(validation),
  });

  const submit = useCallback(
    (data) =>
      !isUndefined(item)
        ? loader(
            VerificationService.updateKycStatuses(item.fraudCheckId, data)
              .then(() => router.stateService.reload())
              .catch(noop)
          )
        : Promise.resolve(),
    [item, router, loader]
  );

  return (
    <form onSubmit={handleSubmit(submit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="note"
            render={({ field, fieldState: { error } }) => (
              <TextField
                fullWidth
                label="Note"
                {...field}
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Button type="submit" fullWidth>
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

const SaveDeclinedReasons: FunctionComponent<ISaveDeclinedReasonsProps> = () => {
  const { changesAmount } = useContext(SingleKycContext);

  const { setOverlay } = useContext(GlobalOverlayContext);

  const onConsentOverlay = useCallback(
    () =>
      setOverlay({
        title: "Confirm Changes",
        children: <Modal />,
      }),
    [setOverlay]
  );

  return changesAmount > 0 ? (
    <StyledButton colour="warning" onClick={onConsentOverlay}>
      Save Decline Codes (+{changesAmount})
    </StyledButton>
  ) : null;
};

export default SaveDeclinedReasons;
